export const cardTexts = {
  whoWeAre: {
    title: "Quem Somos",
    description:
      "A Simya Capital é mais do que uma consultoria ou uma empresa de investimentos. Somos uma equipe experiente e visionária, dedicada a transformar situações complexas em oportunidades de geração de valor para empresas e investidores.",
  },
  expertise: {
    title: "Nossa Expertise",
    description:
      "Combinamos expertise em mercado financeiro, negociações corporativas e litigios estrategicos para oferecer soluções inovadoras e eficazes",
  },
  multiTeam: {
    title: "Equipe multidisciplinar",
    description:
      "Contamos com uma equipe altamente qualificada e experiente em diversas áreas, garantindo uma visão multidisciplinar e soluções completas",
  },
  strategy: {
    title: "Visão estratégica",
    description:
      "Identificamos oportunidades onde outros veem desafios, utilizando inteligência, tecnologia, criatividade e um olhar aguçado para o futuro",
  },
  transparency: {
    title: "Transparência",
    description:
      "Acreditamos na comunicação clara e direta, mantendo nossos clientes sempre informados e engajados, desde o primeiro contato e em cada etapa do processo",
  },
  lamp: {
    title: "Abordagem inovadora e personalizada",
    description:
      "Desenvolvemos soluções sob medida para atender às necessidades específicas de cada cliente",
  },
  success: {
    title: "Histórico de sucesso",
    description:
      "Nosso histórico de resultados comprovados demonstra a capacidade de gerar valor para empresas e investidores",
  },
  security: {
    title: "Segurança como prioridade",
    description:
      "Em um mercado em que os negócios são permeados por incertezas, a segurança dos nossos clientes é a base para tudo que fazemos. Adotamos as melhores práticas de mercado e um rigoroso processo de análise para mitigar riscos e viabilizar investimentos sólidos e confiáveis",
  },
};
